import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatDialogModule } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatCardModule } from '@angular/material/card';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { DxDateBoxModule } from 'devextreme-angular';

import { RtTripShopFormDialogComponent } from './rt-shop-form-dialog/rt-shop-form-dialog.component';
import { RtShopFormService } from './rt-shop-form.service';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { BourqueCoreModule } from '@bds/core';
import { MatSelectModule } from '@angular/material/select';
import { BdsDateTimePickerModule } from '@bds/smart-components';
import { MatTableModule } from '@angular/material/table';

@NgModule({
    declarations: [RtTripShopFormDialogComponent],
    imports: [
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        BourqueCoreModule,
        MatDialogModule,
        MatFormFieldModule,
        MatInputModule,
        MatButtonModule,
        MatSelectModule,
        BdsDateTimePickerModule,
        MatCardModule,
        MatProgressSpinnerModule,
        MatTableModule,
        MatDatepickerModule,
        DxDateBoxModule,
    ],
    providers: [RtShopFormService],
    exports: [RtTripShopFormDialogComponent],
})
export class RtShopFormModule {}
